import React from 'react'
import Resx from '@/components/Resx'
import fieldNameTransform from '@/utils/fieldNameTransform'

const ServerErrorViewer = ({ error, showErrorMessage }) => {
  if (!error) return null

  return error.message && showErrorMessage
    ? <React.Fragment>{ error.localizedMessage ? error.localizedMesage : <Resx name={error.message} /> }
      <ValidationErrorViewer errors={error.validationErrors || []} />
    </React.Fragment>
    : <ValidationErrorViewer errors={error.validationErrors || []} />
}
const ValidationErrorViewer = ({ errors }) =>
  (errors && errors.length > 0)
    ? <ul className='errors'>
      { errors.map((err, index) => <li key={index}>{ SwitchMessageType(err) }</li>) }
    </ul>
    : null

const SwitchMessageType = (err) => {
  if (typeof err === 'string') {
    return err
  } else if (err.localizedMessage) {
    return err.localizedMessage
  } else if (err.message && err.members && Array.isArray(err.members)) {
    return <Resx name={err.message} params={err.members.map(x => fieldNameTransform(x))} />
  }
}

export {
  ServerErrorViewer
}



// WEBPACK FOOTER //
// ./src/components/validation/serverErrorViewer.js